import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  VStack,
  HStack,
  Heading,
  Text,
  Button,
  Icon,
  Badge,
} from '@chakra-ui/react';
import {
  FiCheckCircle,
  FiFileText,
  FiPackage,
  FiHome,
} from 'react-icons/fi';
import { apiUrl } from "../ApiUrl/ApiUrl";

const PaymentCallbackHdfc = () => {
  const navigate = useNavigate();
  const [orderId, setOrderId] = useState("");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const ordId = urlParams.get("orderId");
    if (ordId) {
      setOrderId(ordId);
      fetch(`${apiUrl}/public/invoice?orderId=${ordId}`, {
        method: "GET",
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to verify payment status.");
          }
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }, []);

  return (
    <Box bg="#F8FAFC" minH="85vh" py={{ base: 10, md: 16 }} display="flex" alignItems="center">
      <Container maxW="md" px={4}>
        <Box
          bg="white"
          borderRadius="2xl"
          p={{ base: 6, md: 8 }}
          boxShadow="sm"
          border="1px solid"
          borderColor="gray.100"
          textAlign="center"
        >
          <Box
            w="72px"
            h="72px"
            mx="auto"
            mb={4}
            borderRadius="full"
            bg="emerald.50"
            color="#059669"
            display="flex"
            alignItems="center"
            justifyContent="center"
            boxShadow="0 0 0 10px rgba(16, 185, 129, 0.08)"
          >
            <Icon as={FiCheckCircle} boxSize={9} />
          </Box>

          <Badge
            bg="rgba(16, 185, 129, 0.1)"
            color="#059669"
            px={3}
            py={1}
            borderRadius="full"
            fontSize="xs"
            fontWeight="bold"
            textTransform="uppercase"
            mb={2}
          >
            HDFC SmartHub Verified
          </Badge>

          <Heading size="lg" color="#162237" mb={2}>
            Payment Successful!
          </Heading>
          <Text fontSize="sm" color="gray.600" mb={4}>
            Your judicial order {orderId && <strong style={{ color: '#162237' }}>#{orderId}</strong>} has been successfully authorized and queued for dispatch.
          </Text>

          <Text fontSize="xs" color="gray.400" mb={6}>
            A confirmation receipt and courier tracking details will be dispatched to your registered address.
          </Text>

          <VStack spacing={3} align="stretch">
            {orderId && (
              <Button
                as={Link}
                to={`/invoice?orderId=${orderId}`}
                size="lg"
                bg="#162237"
                color="white"
                leftIcon={<FiFileText />}
                _hover={{ bg: '#0B132B' }}
              >
                View & Download Tax Invoice
              </Button>
            )}
            <HStack spacing={3}>
              <Button
                as={Link}
                to="/orderpage"
                flex={1}
                variant="outline"
                borderColor="gray.200"
                leftIcon={<FiPackage />}
                _hover={{ bg: 'gray.50' }}
              >
                My Orders
              </Button>
              <Button
                as={Link}
                to="/"
                flex={1}
                variant="outline"
                borderColor="gray.200"
                leftIcon={<FiHome />}
                _hover={{ bg: 'gray.50' }}
              >
                Store Home
              </Button>
            </HStack>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

export default PaymentCallbackHdfc;
